import { apiRequest } from "../../helpers/api";

// Saves edits to an existing post, then applies its status: Draft/Ready go through the update,
// Scheduled goes through the schedule endpoint (only when the time or status actually changes).
export const updatePostWithStatus = async (original, body, status, scheduledAt) => {
  const statusChange = status !== "SCHEDULED" && status !== original.status ? { status } : {};
  let saved = (await apiRequest(`/api/posts/${original.id}`, { method: "PUT", body: JSON.stringify({ ...body, ...statusChange }) })).post;
  const timeChanged = status === "SCHEDULED" && scheduledAt &&
    (original.status !== "SCHEDULED" || new Date(original.scheduledAt).getTime() !== new Date(scheduledAt).getTime());
  if (timeChanged) saved = (await apiRequest(`/api/posts/${original.id}/schedule`, { method: "POST", body: JSON.stringify({ scheduledAt }) })).post;
  return saved;
};
